import auth from "../../middlewares/auth";

export const customerRoutes = [
    {
        path: '/customers',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/Customer'),
        name: 'customers',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['customer-manage']
        }
    },
    {
        path: '/customer/:id',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/CustomerForm'),
        name: 'update-customer',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['customer-manage']
        }
    },
    {
        path: '/create-customer',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/CustomerForm'),
        name: 'create-customer',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['customer-manage']
        }
    },
    {
        path: '/customer/:id/show',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/ViewCustomer'),
        name: 'view-customer',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['customer-manage']
        }
    },

]